import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './LLD.css';
import { getRequest, postRequest } from '../../Fetch/request';
import Loader from '../Loader/Loader';
import CreateProblemDialog from '../Common/CreateProblemDialog';
import { useAuth } from '../../hooks/useAuth';
import SEOHead from '../SEO/SEOHead';

import { 
  Box, 
  Typography, 
  Alert,
  Container,
  Paper,
  Tabs,
  Tab,
  Button,
  IconButton,
  Tooltip,
  Chip,
  Card,
  CardContent,
  Grid,
  Pagination,
  PaginationItem
} from '@mui/material';

import LightbulbIcon from '@mui/icons-material/Lightbulb';
import BusinessIcon from '@mui/icons-material/Business';
import StorefrontIcon from '@mui/icons-material/Storefront';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import SchoolIcon from '@mui/icons-material/School';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import SecurityIcon from '@mui/icons-material/Security';
import NotificationsIcon from '@mui/icons-material/Notifications';
import EventIcon from '@mui/icons-material/Event';
import SupportIcon from '@mui/icons-material/Support';
import CodeIcon from '@mui/icons-material/Code';
import CloudIcon from '@mui/icons-material/Cloud';
import StorageIcon from '@mui/icons-material/Storage';
import AssessmentIcon from '@mui/icons-material/Assessment';
import FolderIcon from '@mui/icons-material/Folder';
import QueueIcon from '@mui/icons-material/Queue';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import LocalMallIcon from '@mui/icons-material/LocalMall';
import ReceiptIcon from '@mui/icons-material/Receipt';
import DescriptionIcon from '@mui/icons-material/Description';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AddIcon from '@mui/icons-material/Add';
import FilterListIcon from '@mui/icons-material/FilterList';

// Tab Panel component
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`lld-tabpanel-${index}`}
      aria-labelledby={`lld-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const getCompanyIcon = (companyName) => {
  const company = companyName.toLowerCase();
  
  // Tech Companies
  if (company.includes('google')) return <BusinessIcon sx={{ fontSize: '0.8rem' }} />;
  if (company.includes('amazon')) return <StorefrontIcon sx={{ fontSize: '0.8rem' }} />;
  if (company.includes('microsoft')) return <CodeIcon sx={{ fontSize: '0.8rem' }} />;
  if (company.includes('meta') || company.includes('facebook')) return <BusinessIcon sx={{ fontSize: '0.8rem' }} />;
  if (company.includes('twitter')) return <NotificationsIcon sx={{ fontSize: '0.8rem' }} />;
  if (company.includes('oracle')) return <CloudIcon sx={{ fontSize: '0.8rem' }} />;
  if (company.includes('apple')) return <BusinessIcon sx={{ fontSize: '0.8rem' }} />;
  if (company.includes('atlassian')) return <CodeIcon sx={{ fontSize: '0.8rem' }} />;
  if (company.includes('salesforce')) return <CloudIcon sx={{ fontSize: '0.8rem' }} />;
  if (company.includes('netflix')) return <BusinessIcon sx={{ fontSize: '0.8rem' }} />;
  if (company.includes('grafana')) return <AssessmentIcon sx={{ fontSize: '0.8rem' }} />;
  if (company.includes('datadog')) return <AssessmentIcon sx={{ fontSize: '0.8rem' }} />;
  if (company.includes('sap')) return <BusinessIcon sx={{ fontSize: '0.8rem' }} />;
  if (company.includes('zendesk')) return <SupportIcon sx={{ fontSize: '0.8rem' }} />;
  if (company.includes('freshdesk')) return <SupportIcon sx={{ fontSize: '0.8rem' }} />;
  
  // E-commerce & Retail
  if (company.includes('flipkart')) return <ShoppingCartIcon sx={{ fontSize: '0.8rem' }} />;
  if (company.includes('walmart')) return <StorefrontIcon sx={{ fontSize: '0.8rem' }} />;
  if (company.includes('uber')) return <LocalShippingIcon sx={{ fontSize: '0.8rem' }} />;
  if (company.includes('swiggy')) return <RestaurantIcon sx={{ fontSize: '0.8rem' }} />;
  if (company.includes('zomato')) return <RestaurantIcon sx={{ fontSize: '0.8rem' }} />;
  if (company.includes('bookmyshow')) return <EventIcon sx={{ fontSize: '0.8rem' }} />;
  if (company.includes('paytm')) return <AccountBalanceIcon sx={{ fontSize: '0.8rem' }} />;
  if (company.includes('slack')) return <NotificationsIcon sx={{ fontSize: '0.8rem' }} />;
  if (company.includes('discord')) return <NotificationsIcon sx={{ fontSize: '0.8rem' }} />;
  
  // Financial
  if (company.includes('jp morgan') || company.includes('jpmorgan')) return <AccountBalanceIcon sx={{ fontSize: '0.8rem' }} />;
  if (company.includes('wells fargo')) return <AccountBalanceIcon sx={{ fontSize: '0.8rem' }} />;
  if (company.includes('goldman sachs')) return <AccountBalanceIcon sx={{ fontSize: '0.8rem' }} />;
  
  // Others
  if (company.includes('infosys')) return <BusinessIcon sx={{ fontSize: '0.8rem' }} />;
  if (company.includes('tcs')) return <BusinessIcon sx={{ fontSize: '0.8rem' }} />;
  if (company.includes('google docs')) return <DescriptionIcon sx={{ fontSize: '0.8rem' }} />;
  
  // Default icon
  return <BusinessIcon sx={{ fontSize: '0.8rem' }} />;
};

export default function LLDProblemsList(){
  const [problems, setProblems] = useState([]);
  const [workspaceProblems, setWorkspaceProblems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [workspaceLoading, setWorkspaceLoading] = useState(true);
  const [totalProblems, setTotalProblems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [hasPrevPage, setHasPrevPage] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [createDialogOpen, setCreateDialogOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useAuth();
  
  // Get userId from localStorage with fallback for non-authenticated users
  const userId = localStorage.getItem('userId') || (JSON.parse(localStorage.getItem('profileObject') || '{}').id) || 'slazysloth_user';
  
  // Pagination parameters
  const limit = 25; // Number of problems per page
  const page = new URLSearchParams(location.search).get('page') || 1;

  const fetchProblems = async (pageNum = 1) => {
    setLoading(true);
    try {
      const response = await getRequest(
        process.env.REACT_APP_URL + `/lld-problems?page=${pageNum}&limit=${limit}&userId=${userId}&id=slazysloth`
      );
      
      if (response?.status === '200' && response.response) {
        // Handle the actual API response format
        const problemsData = Array.isArray(response.response) ? response.response : [];
        setProblems(problemsData);
        setTotalProblems(problemsData.length);
        setCurrentPage(pageNum);
        
        // For now, we'll show pagination if we have more than the limit
        // In a real implementation, the backend should return pagination metadata
        setHasNextPage(problemsData.length >= limit);
        setHasPrevPage(pageNum > 1);
      } else {
        setProblems([]);
      }
    } catch (error) {
      setProblems([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchWorkspaceProblems = async () => {
    setWorkspaceLoading(true);
    try {
      const response = await getRequest(
        process.env.REACT_APP_URL + `/lld-problems?userId=${userId}&id=${userId}`
      );
      
      if (response?.status === '200') {
        setWorkspaceProblems(response.response || []);
      } else {
        setWorkspaceProblems([]);
      }
    } catch (error) {
      setWorkspaceProblems([]);
    } finally {
      setWorkspaceLoading(false);
    }
  };

  useEffect(() => {
    const pageNum = parseInt(page, 10);
    if (!isNaN(pageNum) && pageNum > 0) {
      fetchProblems(pageNum);
    } else {
      fetchProblems(1);
    }
    // Only fetch workspace problems for authenticated users
    if (isAuthenticated) {
      fetchWorkspaceProblems();
    } else {
      setWorkspaceProblems([]);
      setWorkspaceLoading(false);
    }
  }, [page, isAuthenticated]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= Math.ceil(totalProblems / limit)) {
      navigate(`/lld?page=${newPage}`);
    }
  };

  const handleCreateProblem = () => {
    if (!isAuthenticated) {
      alert('Please login to create problems');
      return;
    }
    setCreateDialogOpen(true);
  };

  const handleProblemCreated = () => {
    setCreateDialogOpen(false);
    fetchWorkspaceProblems(); // Refresh the workspace problems list
  };

  if(loading && workspaceLoading) return (
    <div className="loading-fade">
      <Loader />
    </div>
  );

  return(
    <Container maxWidth="lg" sx={{ marginTop: '20px' }}>
      <SEOHead 
        title="Low Level Design (LLD) Practice - Design Patterns & OOPS | SlazySloth"
        description="Master Low Level Design with hands-on practice. Learn design patterns, SOLID principles, object-oriented programming, and system design fundamentals. Perfect for software engineering interviews."
        keywords="low level design, LLD, design patterns, SOLID principles, object oriented programming, OOPS, software design, system design, design patterns interview, singleton pattern, factory pattern, observer pattern, strategy pattern"
        url="https://slazysloth.com/lld"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "Course",
          "name": "Low Level Design (LLD) Practice",
          "description": "Comprehensive Low Level Design practice with design patterns and OOPS concepts",
          "provider": {
            "@type": "Organization",
            "name": "SlazySloth"
          },
          "educationalLevel": "Intermediate to Advanced",
          "teaches": ["Design Patterns", "SOLID Principles", "Object-Oriented Programming", "Software Architecture", "System Design"]
        }}
      />
      
      {/* Header Section */}
      <Box sx={{ mb: 4, textAlign: 'center' }}>
        <Typography component="h1" variant="h3" sx={{ fontWeight: 'bold', mb: 2, color: '#333' }}>
          Low Level Design (LLD) Practice
        </Typography>
        <Typography variant="h6" sx={{ color: '#666', maxWidth: 900, mx: 'auto', mb: 3 }}>
          Master software design with hands-on LLD problems. Practice design patterns, SOLID principles, 
          and object-oriented programming concepts essential for system design interviews.
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, flexWrap: 'wrap' }}>
          <Chip label="Design Patterns" color="primary" variant="outlined" />
          <Chip label="SOLID Principles" color="primary" variant="outlined" />
          <Chip label="OOPS Concepts" color="primary" variant="outlined" />
          <Chip label="Software Architecture" color="primary" variant="outlined" />
        </Box>
      </Box>

      <Box sx={{ mb: 3 }}>
      </Box>

      <Paper elevation={0} sx={{ borderRadius: '8px', overflow: 'hidden', backgroundColor: 'transparent' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Tabs 
            value={activeTab} 
            onChange={handleTabChange}
            sx={{
              '& .MuiTab-root': {
                fontWeight: 'bold',
                fontSize: '16px',
                textTransform: 'none',
                minHeight: '64px'
              },
              '& .Mui-selected': {
                color: '#008080 !important'
              },
              '& .MuiTabs-indicator': {
                backgroundColor: '#008080'
              }
            }}
          >
            <Tab label="Default Problems" />
            <Tab label="My Workspace" />
          </Tabs>
          
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleCreateProblem}
            sx={{
              backgroundColor: '#008080',
              '&:hover': { backgroundColor: '#006666' },
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: 'bold',
              mr: 2
            }}
          >
            Add Problem
          </Button>
        </Box>

        {/* Default Problems Tab */}
        <TabPanel value={activeTab} index={0}>

          {/* Problems List */}
          {loading ? (
            <Box sx={{ 
              display: 'flex',
              justifyContent: 'center', 
              alignItems: 'center',
              minHeight: '150px'
            }}>
              <Loader />
            </Box>
          ) : problems.length > 0 ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {problems.map((problem) => (
                <Card 
                  key={problem.problemId}
                  sx={{ 
                    cursor: 'pointer',
                    borderRadius: '8px',
                    transition: 'all 0.2s ease-in-out',
                    '&:hover': {
                      transform: 'translateY(-2px)',
                      boxShadow: 4
                    }
                  }}
                  onClick={() => navigate(`/lld/problem?problemId=${problem.problemId}`)}
                >
                  <CardContent sx={{ p: 3 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                      {/* Question Section */}
                      <Box sx={{ flex: 1, mr: 2 }}>
                        <Typography variant="h6" sx={{ 
                          fontWeight: 'bold', 
                          color: '#333',
                          mb: 1
                        }}>
                          {problem.title}
                        </Typography>
                        <Typography variant="body2" sx={{ 
                          color: '#666', 
                          lineHeight: 1.5
                        }}>
                          {problem.description}
                        </Typography>
                      </Box>

                      {/* Difficulty Badge */}
                      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                        <Chip
                          label={problem.difficultyLevel || 'Medium'}
                          size="small"
                          sx={{
                            backgroundColor: problem.difficultyLevel === 'Hard' ? '#d32f2f' : 
                                             problem.difficultyLevel === 'Easy' ? '#2e7d32' : '#ed6c02',
                            color: 'white',
                            fontWeight: 'bold',
                            fontSize: '0.75rem'
                          }}
                        />
                      </Box>
                    </Box>

                    {/* Companies Icons - Inline with description */}
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', mt: 2 }}>
                      {problem.companyTags && problem.companyTags.length > 0 ? (
                        problem.companyTags.slice(0, 2).map((company, index) => {
                          const companyIcon = getCompanyIcon(company);
                          return (
                            <Box
                              key={index}
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 0.5
                              }}
                            >
                              <Box
                                sx={{
                                  width: 20,
                                  height: 20,
                                  borderRadius: '4px',
                                  border: '1px solid #1976d2',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  backgroundColor: 'white'
                                }}
                              >
                                {companyIcon}
                              </Box>
                              <Typography 
                                variant="caption" 
                                sx={{ 
                                  color: '#1976d2', 
                                  fontSize: '0.7rem',
                                  fontWeight: 'bold'
                                }}
                              >
                                {company}
                              </Typography>
                            </Box>
                          );
                        })
                      ) : (
                        <Typography variant="caption" sx={{ color: '#999', fontSize: '0.75rem' }}>
                          -
                        </Typography>
                      )}
                    </Box>
                  </CardContent>
                </Card>
              ))}
            </Box>
          ) : (
            <Box sx={{ textAlign: 'center', py: 8 }}>
              <Typography variant="h6" color="text.secondary">
                No LLD problems found.
              </Typography>
            </Box>
          )}

          {/* Pagination */}
          {problems.length > 0 && (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
              <Pagination
                count={Math.ceil(totalProblems / limit)}
                page={currentPage}
                onChange={(event, page) => handlePageChange(page)}
                color="primary"
                size="large"
                showFirstButton
                showLastButton
              />
            </Box>
          )}
        </TabPanel>

        {/* My Workspace Tab */}
        <TabPanel value={activeTab} index={1}>

          {workspaceLoading ? (
            <Box sx={{ 
              display: 'flex',
              justifyContent: 'center', 
              alignItems: 'center',
              minHeight: '150px'
            }}>
              <Loader />
            </Box>
          ) : workspaceProblems.length > 0 ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {workspaceProblems.map((problem) => (
                <Card 
                  key={problem.problemId}
                  sx={{ 
                    cursor: 'pointer',
                    borderRadius: '8px',
                    transition: 'all 0.2s ease-in-out',
                    '&:hover': {
                      transform: 'translateY(-2px)',
                      boxShadow: 4
                    }
                  }}
                  onClick={() => navigate(`/lld/problem?problemId=${problem.problemId}&workspace=true`)}
                >
                  <CardContent sx={{ p: 3 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                      {/* Question Section */}
                      <Box sx={{ flex: 1, mr: 2 }}>
                        <Typography variant="h6" sx={{ 
                          fontWeight: 'bold', 
                          color: '#333',
                          mb: 1
                        }}>
                          {problem.title}
                        </Typography>
                        <Typography variant="body2" sx={{ 
                          color: '#666', 
                          lineHeight: 1.5
                        }}>
                          {problem.description}
                        </Typography>
                      </Box>

                      {/* Difficulty Badge */}
                      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                        <Chip
                          label={problem.difficultyLevel || 'Medium'}
                          size="small"
                          sx={{
                            backgroundColor: problem.difficultyLevel === 'Hard' ? '#d32f2f' : 
                                             problem.difficultyLevel === 'Easy' ? '#2e7d32' : '#ed6c02',
                            color: 'white',
                            fontWeight: 'bold',
                            fontSize: '0.75rem'
                          }}
                        />
                      </Box>
                    </Box>

                    {/* Companies Icons - Inline with description */}
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', mt: 2 }}>
                      {problem.companyTags && problem.companyTags.length > 0 ? (
                        problem.companyTags.slice(0, 2).map((company, index) => {
                          const companyIcon = getCompanyIcon(company);
                          return (
                            <Box
                              key={index}
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 0.5
                              }}
                            >
                              <Box
                                sx={{
                                  width: 20,
                                  height: 20,
                                  borderRadius: '4px',
                                  border: '1px solid #1976d2',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  backgroundColor: 'white'
                                }}
                              >
                                {companyIcon}
                              </Box>
                              <Typography 
                                variant="caption" 
                                sx={{ 
                                  color: '#1976d2', 
                                  fontSize: '0.7rem',
                                  fontWeight: 'bold'
                                }}
                              >
                                {company}
                              </Typography>
                            </Box>
                          );
                        })
                      ) : (
                        <Typography variant="caption" sx={{ color: '#999', fontSize: '0.75rem' }}>
                          -
                        </Typography>
                      )}
                    </Box>
                  </CardContent>
                </Card>
              ))}
            </Box>
          ) : (
            <Box sx={{ 
              textAlign: 'center', 
              py: 6,
              backgroundColor: '#f9f9f9',
              borderRadius: '8px'
            }}>
              <CodeIcon sx={{ fontSize: 60, color: '#ccc', mb: 2 }} />
              <Typography variant="h6" sx={{ color: '#666', mb: 1 }}>
                No Workspace Problems Yet
              </Typography>
              <Typography variant="body2" sx={{ color: '#999', mb: 3 }}>
                Create your first LLD problem in your workspace
              </Typography>
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={handleCreateProblem}
                sx={{
                  backgroundColor: '#008080',
                  '&:hover': { backgroundColor: '#006666' },
                  borderRadius: '8px',
                  textTransform: 'none',
                  fontWeight: 'bold'
                }}
              >
                Create Your First Problem
              </Button>
            </Box>
          )}
        </TabPanel>
      </Paper>

      <CreateProblemDialog
        open={createDialogOpen}
        onClose={() => setCreateDialogOpen(false)}
        onProblemCreated={handleProblemCreated}
        problemType="LLD"
      />
    </Container>
  );
} 